import { Turnstile } from "@marsidev/react-turnstile";
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";

// IMPORTANT: Remplacez VOTRE_SITE_KEY_ICI par votre vraie Site Key Turnstile
// Obtenez-la sur https://dash.cloudflare.com/?to=/:account/turnstile
// Domaines autorisés: *.lovableproject.com
const TURNSTILE_SITE_KEY = "0x4AAAAAAB6FNxLC403zDCcK";

interface TurnstileCaptchaProps {
  onVerify: (isValid: boolean, token?: string) => void;
  onError?: (error: string) => void;
}

export const TurnstileCaptcha = ({ onVerify, onError }: TurnstileCaptchaProps) => {
  

  const handleVerify = async (token: string) => {
    // Ne pas vérifier ici car les tokens Turnstile sont à usage unique
    // La vérification se fera lors de la soumission du formulaire
    onVerify(true, token);
  };

  const handleError = () => {
    onVerify(false);
    onError?.("Erreur de chargement du CAPTCHA");
  };

  return (
    <div className="flex justify-center my-4">
      <Turnstile
        siteKey={TURNSTILE_SITE_KEY}
        onSuccess={handleVerify}
        onError={handleError}
        onExpire={() => onVerify(false)}
        options={{
          theme: "light",
          size: "normal",
        }}
      />
      
    </div>
  );
};
